import Pagination from './src/pagination';

module.exports = Pagination;


// WEBPACK FOOTER //
// ./src/components/pagination/index.js